






































import {Component} from "vue-property-decorator";
import {mixins} from "vue-class-component";
import {CommonMixin} from "@/shared/services/mixin";
import {PositionShipper} from "@/interfaces/entity";
import {listPositionShipper} from "@/modules/positionshipper/service";
import moment from "moment";

    @Component({
        name: "PositionShipper",
    })

    export default class extends mixins(CommonMixin) {
      currentLocation = {lat: 21.036860, lng: 105.834663};
      onlines: Array<PositionShipper> = [];
      offlines: Array<PositionShipper> = [];
      timeOnline = 5 * 60 * 1000;
      platform: any;
      map: any;
      maptypes: any;
      positionData: any;
      appId = process.env.VUE_APP_HERE_MAP_APP_ID;
      apiKey = process.env.VUE_APP_HERE_MAP_API_KEY;
      mounted() {
        this.platform = new (window as any).H.service.Platform({
          "appid": this.appId,
          "apikey": this.apiKey,
          "useHTTPS": true,
          "useCIT": true
        });

        this.initializeHereMap();
        this.getPositionShipper();
      }

      initializeHereMap() { // rendering map
        const mapContainer = document.getElementById('map');
        // Obtain the default map types from the platform object
        this.maptypes = this.platform.createDefaultLayers();

        // Instantiate (and display) a map object:
        this.map = new (window as any).H.Map(mapContainer, this.maptypes.vector.normal.map, {
          center: this.currentLocation,
          zoom: 14,
          pixelRatio: window.devicePixelRatio || 1
        });

        addEventListener("resize", () => this.map.getViewPort().resize());
        const behavior = new (window as any).H.mapevents.Behavior(new (window as any).H.mapevents.MapEvents(this.map));
        (window as any).H.ui.UI.createDefault(this.map, this.maptypes);
      }

      async getPositionShipper() {
        try {
          this.offlines = [];
          this.onlines = [];
          const { data } = await listPositionShipper({ page: 1, limit: 2000 });
          const now = (new Date()).valueOf();
          this.positionData = data?.datas;
          data?.datas?.forEach((position: PositionShipper) => {
            const timeOnlineLatest = moment(position.updatedDate, "HH:mm DD MM YYYY").valueOf();
            if (now - timeOnlineLatest > this.timeOnline) {
              this.offlines.push(position)
            } else {
              this.onlines.push(position)
            }
          })
          this.addInfoBubble(this.map, this.maptypes);
        } catch (e) {
          this.$message.error(e?.response?.data?.message || "Đã xảy ra lỗi");
        }
      }

      addInfoBubble(map, maptypes) {
        const group = new (window as any).H.map.Group();

        map.addObject(group);

        group.addEventListener('tap', function (evt) {
          const bubble = new (window as any).H.ui.InfoBubble(evt.target.getGeometry(), {
            content: evt.target.getData()
          });
          // show info bubble
          (window as any).H.ui.UI.createDefault(map, maptypes)!.addBubble(bubble);
        }, false);

        this.positionData.forEach((position: PositionShipper) => {
          const html = `<div style="width: 150px; height: 15px; font-size: 12px">${position.account?.employee?.fullname}</div>`;
          this.addMarkerToGroup(group, {lat: position.latitude, lng: position.longitude},
              html);
          const bubble = new (window as any).H.ui.InfoBubble({lat: position.latitude, lng: position.longitude}, {
            content: html
          });
          // show info bubble
          (window as any).H.ui.UI.createDefault(map, maptypes)!.addBubble(bubble);
        })
      }

      addMarkerToGroup(group, coordinate, html) {
        const marker = new (window as any).H.map.Marker(coordinate);
        // add custom data to the marker
        marker.setData(html);
        group.addObject(marker);
      }

      zoomToEmployeePosition(position: any) {
        const mapContainer = document.getElementById('map');
        mapContainer!.innerHTML = "";
        // Obtain the default map types from the platform object
        this.maptypes = this.platform.createDefaultLayers();

        // Instantiate (and display) a map object:
        this.map = new (window as any).H.Map(mapContainer, this.maptypes.vector.normal.map, {
          center: {lat: position.latitude, lng: position.longitude},
          zoom: 30,
          pixelRatio: window.devicePixelRatio || 1
        });

        addEventListener("resize", () => this.map.getViewPort().resize());
        const behavior = new (window as any).H.mapevents.Behavior(new (window as any).H.mapevents.MapEvents(this.map));
        (window as any).H.ui.UI.createDefault(this.map, this.maptypes);
        this.getPositionShipper()
      }
    }
